import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_More(
        selectedItems: any[],
        isInOneDrive: boolean,
        menuItem_Checkout: IContextualMenuItem,
        menuItem_Checkin: IContextualMenuItem,
        menuItem_DiscardCheckout: IContextualMenuItem,
        menuItem_Publish: IContextualMenuItem,
        menuItem_Unpublish: IContextualMenuItem,
        menuItem_VersionAppRej: IContextualMenuItem,
        ) {
    const languageStrings = React.useContext(LanguageContext);
    
    const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);
    const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
    
    const [menuItem_More, setMenuItem_More] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
            const moreItem: IContextualMenuItem = {
                key: "more",
                disabled: isBusySaving === true,
                text: languageStrings.More,
                iconProps: { iconName: "MoreVertical" },
                subMenuProps: {
                    items: []
                }
            }

            if (menuItem_Checkout) {
                moreItem.subMenuProps.items.push(menuItem_Checkout);
            }
            
            if (menuItem_Checkin) {
                moreItem.subMenuProps.items.push(menuItem_Checkin);
            }

            if (menuItem_DiscardCheckout) {
                moreItem.subMenuProps.items.push(menuItem_DiscardCheckout);
            }

            if (menuItem_Publish) {
                moreItem.subMenuProps.items.push(menuItem_Publish);
            }

            if (menuItem_Unpublish) {
                moreItem.subMenuProps.items.push(menuItem_Unpublish);
            }

            if (menuItem_VersionAppRej) {
                moreItem.subMenuProps.items.push(menuItem_VersionAppRej);
            }

            setMenuItem_More(moreItem.subMenuProps.items.length > 0 ? moreItem : null);
    }, [selectedItems, currentSharepointFolder, menuItem_Checkout, menuItem_Checkin, menuItem_DiscardCheckout, menuItem_Publish, menuItem_Unpublish, menuItem_VersionAppRej, isInOneDrive])
    
    return {
        menuItem_More
    }

}